import { Link } from 'react-router-dom';
import { RegisterForm } from '../../components/auth';
import { AuthLayout } from '../../components/layouts';

export function RegisterPage() {
  return (
    <AuthLayout
      title="Create Account"
      subtitle={
        <>
          Already have an account?{' '}
          <Link to="/login">Log in</Link>
        </>
      }
    >
      <RegisterForm />
    </AuthLayout>
  );
}
